import { OnboardingRouteRedirect } from '../../components';

export default function Step1SubscriptionRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)" />;
}
